export enum VerificationCodeEnum {
  EMAIL_VERIFICATION = 'EMAIL_VERIFICATION',
  PASSWORD_RESET = 'PASSWORD_RESET',
  ACCOUNT_RESTORE = 'ACCOUNT_RESTORE',
}
